import { useAuth } from '@/contexts/AuthContext';
import type { UserRole } from '@/contexts/AuthContext';

export type { UserRole };

export function useUserRole() {
  const { role, roleLoading, isPro, refreshRole } = useAuth();
  return { role, loading: roleLoading, isPro, refreshRole };
}
